import { ComponentType, Dispatch, ReactNode, SetStateAction } from 'react';
import { IconName } from '@optimus-web/icons';
import { Avatar, AvatarProps } from '../Avatar';
import { SideMenuPanel } from '../SideMenu';
import { MenuCardButton, MenuCardIcon, MenuCardSubtitle, MenuCardText, MenuCardTitle } from './style';

export interface MenuCardProps {
    title: ReactNode;
    collapsed?: boolean;
    subtitle?: ReactNode;
    avatar: AvatarProps;
    children?: ReactNode;
    id: string;
    expandedItem?: string | null;
    onExpandableChange?: Dispatch<SetStateAction<string | null>>;
    onClick?: Dispatch<SetStateAction<string>>;
}

interface MenuCardFactoryProps {
    CardMenuAvatar?: ComponentType<AvatarProps>;
}

export const MenuCardFactory = ({ CardMenuAvatar = Avatar }: MenuCardFactoryProps = {}) => {
    const MenuCard = ({
        title,
        collapsed = false,
        subtitle,
        avatar,
        children,
        id,
        expandedItem,
        onExpandableChange,
        onClick,
        ...other
    }: MenuCardProps) => {
        const handleExpandedItem = (expandedId: string | null, expanded: boolean) =>
            onExpandableChange?.(expanded ? null : expandedId);
        const expanded = expandedItem === id;

        return (
            <>
                <MenuCardButton
                    onClick={() => handleExpandedItem(id, expanded)}
                    collapsed={collapsed}
                    id={id}
                    {...other}
                >
                    <CardMenuAvatar {...avatar} size={40} />
                    {collapsed ? null : (
                        <MenuCardText>
                            <MenuCardTitle>{title}</MenuCardTitle>
                            <MenuCardSubtitle>{subtitle}</MenuCardSubtitle>
                        </MenuCardText>
                    )}
                    {!collapsed ? <MenuCardIcon active={expanded} value={IconName.ChevronRight} size="small" /> : null}
                </MenuCardButton>
                {children ? (
                    <SideMenuPanel active={expanded} collapsed={collapsed}>
                        {children}
                    </SideMenuPanel>
                ) : null}
            </>
        );
    };
    return MenuCard;
};

export const MenuCard = MenuCardFactory();
